import React from 'react';

export default function HistoricoAnalise({ historico }) {
  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusIcon = (status) => {
    const statusDesc = status?.descricao?.toLowerCase() || '';
    switch (statusDesc) {
      case 'pendente de análise':
      case 'pendente':
        return 'fas fa-clock';
      case 'devolvida':
        return 'fas fa-undo';
      case 'transferida':
        return 'fas fa-exchange-alt';
      case 'finalizada':
        return 'fas fa-check-double';
      default:
        return 'fas fa-circle';
    }
  };

  const getStatusClass = (status) => {
    const statusDesc = status?.descricao?.toLowerCase() || '';
    switch (statusDesc) {
      case 'pendente de análise':
      case 'pendente':
        return 'historico-pendente';
      case 'devolvida':
        return 'historico-devolvida';
      case 'transferida':
        return 'historico-transferida';
      case 'finalizada':
        return 'historico-finalizada';
      default:
        return 'historico-default';
    }
  };

  if (!historico || historico.length === 0) {
    return (
      <div className="historico-empty">
        <p>Nenhum histórico disponível.</p>
      </div>
    );
  }

  return (
    <div className="historico-analise">
      <div className="historico-timeline">
        {historico.map((item, index) => (
          <div key={item.id} className={`historico-item ${getStatusClass(item.status_info)}`}>
            <div className="historico-icon">
              <i className={getStatusIcon(item.status_info)}></i>
            </div>
            <div className="historico-content">
              <div className="historico-header">
                <h5>{item.status_info?.descricao || 'Status não definido'}</h5>
                <span className="historico-data">{formatarData(item.criado_em)}</span>
              </div>
              <div className="historico-details">
                {item.funcionario_envolvido_info && (
                  <p><strong>Funcionário Envolvido:</strong> {item.funcionario_envolvido_info.nome}</p>
                )}
                {item.funcionario_info && (
                  <p><strong>Alterado por:</strong> {item.funcionario_info.nome}</p>
                )}
                {item.setor_envolvido_info && (
                  <p><strong>Setor:</strong> {item.setor_envolvido_info.descricao}</p>
                )}
                {item.descricao_retorno && (
                  <div className="historico-retorno">
                    <strong>Observações:</strong>
                    <p>{item.descricao_retorno}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}